import Vue from "vue";

import Moment from 'moment';
import { sanitizeCnpj } from "./sanitize";

Vue.filter('formatDateTime', function (value) {
    if (!value) {
        return "";
    }

    if (value) {
        return Moment(String(value)).format('DD/MM/YYYY hh:mm:ss');
    }
});

Vue.filter('formatDate', function (value) {
    if (!value) {
        return "";
    }

    if (value) {
        return Moment(String(value)).format('DD/MM/YYYY');
    }
});

Vue.filter('money', function (value, decimals = 2) {
    if (!value && value !== 0) {
        return "";
    }
    let val = (value / 1).toFixed(decimals).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
});

Vue.filter('moneyIfNumberElseString', function (value, decimals = 2) {
    if (isNaN(Number(value)))
        return value;

    if (!value && value !== 0) {
        return "";
    }
    let val = (value / 1).toFixed(decimals).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
});

Vue.filter("toCapitalized", function (value) {
    if (!value) {
        return "";
    }
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("toUpper", function (value) {
    if (!value) {
        return "";
    }
    value = value.toString();
    return value.toUpperCase();
});

Vue.filter("toLower", function (value) {
    if (!value) {
        return "";
    }

    value = value.toString();
    return value.toLowerCase();
});

export function formatCnpj(value) {
    if (!value && value !== 0) {
        return "";
    }

    let raw = sanitizeCnpj(value);
    if (!raw) {
        return "";
    }

    if (/^\d+$/.test(raw) && raw.length < 14) {
        raw = raw.padStart(14, '0');
    }

    return raw.replace(
        /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{0,2})$/,
        (_, a, b, c, d, e) => a + '.' + b + '.' + c + '/' + d + (e ? '-' + e : '')
    );
}

export function formatCnpjProgressive(value) {
    let raw = String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    let base = '';
    let dv = '';

    for (let i = 0; i < raw.length && base.length + dv.length < 14; i++) {
        const ch = raw[i];
        if (base.length < 12) {
            base += ch;
        } else if (/\d/.test(ch)) {
            dv += ch;
        }
    }

    const indice = (base + dv).match(/([A-Z0-9]{0,2})([A-Z0-9]{0,3})([A-Z0-9]{0,3})([A-Z0-9]{0,4})(\d{0,2})/);
    if (!indice) {
        return '';
    }

    return !indice[2]
        ? indice[1]
        : indice[1] + '.' + indice[2] + '.' + indice[3] + '/' + indice[4] + (indice[5] ? '-' + indice[5] : '');
}

Vue.filter('cnpj', function (value) {
    return formatCnpj(value);
});

Vue.filter('cpf', function (value) {
    if (!value) {
        return "";
    }

    value = value.toString();
    value = value.padStart(11, '0');
    return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
});

Vue.filter('cep', function (value) {
    if (!value) {
        return "";
    }

    value = value.toString();
    value = value.padStart(8, '0');
    return value.replace(/^(\d{5})(\d{3})/, '$1-$2');
});

Vue.filter('phone', function (value) {
    if (!value) {
        return "";
    }

    value = (value.toString() * 1).toString();

    if (value.length == 8) {
        return value.replace(/^(\d{4})(\d{4})/, '$1-$2');
    }

    if (value.length == 9) {
        return value.replace(/^(\d{5})(\d{4})/, '$1-$2');
    }

    if (value.length == 10) {
        return value.replace(/^(\d{2})(\d{4})(\d{4})/, '($1)$2-$3');
    }

    if (value.length == 11) {
        return value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1)$2-$3');
    }

    if (value.length == 12) {
        return value.replace(/^(\d{3})(\d{5})(\d{4})/, '($1)$2-$3');
    }
    return value;
});
